<template>
  <div class="w-full">
    <vx-tooltip :text="$t('add') | capitalize">
      <vs-button
        color="success"
        icon-pack="feather"
        icon="icon-plus"
        type="filled"
        @click="open"
        class="w-full"
      >
        <!-- <span>{{ $t('add') }}</span> -->
      </vs-button>
    </vx-tooltip>
    <vs-popup-custom
      :title="$t('add_new_emails') | capitalize"
      color="danger"
      :active.sync="active"
      :buttonCloseHidden="true"
      :persistent="true"
    >
      <div id="add-emails-loading" class="vs-con-loading__container">
        <form class="px-2">
          <div class="popup-custom-h">
            <vs-row class="mb-2">
              <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
                <span>{{ $tc('client') | capitalize }}</span>
              </vs-col>
              <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
                <v-select
                  v-model="form.client_id"
                  :options="clients"
                  class="w-full select-h"
                  :reduce="(item) => item.ClientId"
                  label="ClientName"
                  :clearable="false"
                />
              </vs-col>
            </vs-row>

            <vs-row class="mb-2">
              <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
                <span>{{ $tc('emails') | capitalize }}</span>
              </vs-col>
              <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
                <vs-input
                  v-model="form.emails"
                  class="w-full"
                />
              </vs-col>
            </vs-row>
          </div>
          <vs-row vs-type="flex" vs-justify="flex-end">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-xs="12"
              vs-sm="3"
              vs-lg="3"
            >
              <vs-button class="w-full mx-2" type="border" @click="close">
                {{ $t('cancel') | capitalize }}
              </vs-button>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-xs="12"
              vs-sm="3"
              vs-lg="3"
            >
              <vs-button
                class="w-full mx-2"
                type="filled"
                color="primary"
                :disabled="disabledSubmit"
                @click="handleSubmit"
              >
                {{ $t('submit') | capitalize }}
              </vs-button>
            </vs-col>
          </vs-row>
        </form>
      </div>
    </vs-popup-custom>
  </div>
</template>

<script>
import VsPopupCustom from '@/views/components/modals/VsPopupCustom.vue'
import loading from '@/mixins/Loading'
import vSelect from 'vue-select'
import request from '../request'

export default {
  components: {
    VsPopupCustom,
    'v-select': vSelect,
  },
  props: {
    vendorId: {
      required: true,
    },
    clients: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
    disabledSubmit() {
      return this.form.client_id === '' || this.form.emails === ''
    },
  },
  data() {
    return {
      active: false,
      form: {
        client_id: '',
        emails: '',
      },
    }
  },
  methods: {
    open() {
      this.form = {
        client_id: '',
        emails: '',
      }
      this.active = true
    },
    close() {
      this.active = false
    },
    validateEmail(emails) {
      const reg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      let result = true
      emails.forEach((email) => {
        if (reg.test(email) == false) {
          result = false
        }
      })
      return result
    },
    handleSubmit() {
      let emails = this.form.emails.split(',')
      if (!this.validateEmail(emails)) {
        this.$vs.notify({
          color: 'warning',
          title: 'Error',
          text: 'Invalid email',
        })
        return
      }
      const payload = {
        vendor: this.vendorId,
        client: this.form.client_id,
        emails: emails,
      }
      this.openLoading('add-emails-loading')
      request
        .addEmails(payload)
        .then((response) => {
          this.closeLoading('add-emails-loading')
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Emails Saved',
          })
          this.close()
          this.$emit('success')
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.closeLoading('add-emails-loading')
        })
    },
  },
  mixins: [loading],
}
</script>

<style>
.select-h > .vs__dropdown-menu {
  height: 50px;
  overflow-x: hidden;
}
.popup-custom-h {
  height: 140px;
}
</style>